import axios from 'axios'

export default {

    getGroupInteractiveContent(group_id) {
        return axios.get(`/interactive-content/group/${group_id}`)
    },

    getInteractiveContent(interactive_content_id) {
        return axios.get(`/interactive-content/${interactive_content_id}`)
    },

    createInteractiveContent(data) {
        return axios.post('/interactive-content', data)
    },

    saveInteractiveContent({ interactive_content_id, data }) {
        return axios.put(`/interactive-content/${interactive_content_id}`, data)
    },

    removeInteractiveContent(interactive_content_id) {
        return axios.delete(`/interactive-content/${interactive_content_id}`)
    },

}
